package com.zq.webproject.ui.profile

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import com.zq.webproject.ui.ranking.MyRankingCard
import com.zq.webproject.utils.TokenManager
import com.zq.webproject.utils.UrlLauncher
import com.zq.webproject.utils.ShareUtils
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.Font
import org.jetbrains.compose.resources.painterResource
import webproject.composeapp.generated.resources.Res
import webproject.composeapp.generated.resources.compose_multiplatform
import webproject.composeapp.generated.resources.font_song

// 统一字体（使用宋体，包含完整中文字符）
private val CaiFont: FontFamily
    @Composable
    get() = FontFamily(Font(Res.font.font_song))


/**
 * 我的页面
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ProfileScreen(
    username: String?,
    onBackClick: () -> Unit,
    onLogout: () -> Unit = {},  // 退出登录回调
    onInviteClick: () -> Unit = {},  // 邀请界面回调
    onInvitedUsersClick: () -> Unit = {},  // 邀请用户列表回调
    onPurchaseRecordClick: () -> Unit = {},  // 购买记录回调
    onWithdrawClick: () -> Unit = {},  // 提现回调
    onRechargeClick: () -> Unit = {},  // 充值回调
    onEarningsRecordClick: () -> Unit = {},  // 收益记录回调
    onRankingClick: () -> Unit = {},  // 排行榜回调
    onAboutClick: () -> Unit = {},  // 关于回调
    onUploadProductClick: () -> Unit = {}  // 上传商品回调
) {
    println("ProfileScreen - 渲染我的页面，用户: $username") // 日志输出

    // 创建 ViewModel 实例
    val viewModel = remember { ProfileViewModel() }

    // 客服联系对话框状态
    var showCustomerServiceDialog by remember { mutableStateOf(false) }

    // 升级支付弹框状态
    var showUpgradeDialog by remember { mutableStateOf(false) }

    // 支付宝二维码弹框状态
    var showAlipayDialog by remember { mutableStateOf(false) }
    var alipayQrcodeUrl by remember { mutableStateOf<String?>(null) }
    var alipayOrderNo by remember { mutableStateOf<String?>(null) }

    // 页面加载时获取余额和角色
    LaunchedEffect(Unit) {
        println("ProfileScreen - 开始加载用户余额和角色") // 日志输出
        viewModel.loadBalance()
        viewModel.loadUserRole()
        viewModel.loadEarnings()
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xFFF5F5F5))
            .systemBarsPadding() // 添加系统栏适配
    ) {
        // 顶部标题栏（带返回按钮）- 固定在顶部，不滚动
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .background(Color.White)
                .padding(vertical = 16.dp, horizontal = 16.dp)
        ) {
            // 返回按钮（左侧）
            IconButton(
                onClick = onBackClick,
                modifier = Modifier.align(Alignment.CenterStart)
            ) {
                Icon(
                    imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                    contentDescription = "返回首页",
                    tint = Color(0xFF333333)
                )
            }

            // 标题（居中）
            Text(
                text = "个人中心",
                fontSize = 18.sp,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF333333),
                fontFamily = CaiFont,
                modifier = Modifier.align(Alignment.Center)
            )

            // 分享按钮（右侧）- 仅在支持的平台显示
            if (ShareUtils.isShareSupported()) {
                IconButton(
                    onClick = {
                        println("ProfileScreen - 点击分享按钮")
                        ShareUtils.shareContent(
                            title = "学库",
                            text = "各种完整教程，助力提升技能",
                            url = "https://shop.aiotzq.com"
                        )
                    },
                    modifier = Modifier.align(Alignment.CenterEnd)
                ) {
                    Icon(
                        imageVector = Icons.Default.Share,
                        contentDescription = "分享",
                        tint = Color(0xFF1E88E5)
                    )
                }
            }
        }

        // 可滚动的内容区域
        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(rememberScrollState())
        ) {
            Spacer(modifier = Modifier.height(20.dp))

            // 用户信息卡片
            UserInfoCard(
                username = username,
                userRole = viewModel.userRole
            )

            Spacer(modifier = Modifier.height(20.dp))

            // 余额卡片
            BalanceCard(
                balance = viewModel.balance,
                isLoading = viewModel.isLoading,
                userRole = viewModel.userRole,
                onUpgradeClick = { showUpgradeDialog = true },
                onWithdrawClick = onWithdrawClick,
                onRechargeClick = onRechargeClick
            )

            Spacer(modifier = Modifier.height(20.dp))

//            // 收藏和喜欢按钮
//            FavoriteAndLikeButtons(
//                onFavoriteClick = {
//                    println("ProfileScreen - 点击收藏按钮")
//                    // TODO: 实现收藏功能
//                },
//                onLikeClick = {
//                    println("ProfileScreen - 点击喜欢按钮")
//                    // TODO: 实现喜欢功能
//                }
//            )

            //           Spacer(modifier = Modifier.height(20.dp))

            // 我的收益卡片
            MyEarningsCard(
                earnings = viewModel.earnings,
                isLoading = viewModel.isLoading,
                onEarningsRecordClick = onEarningsRecordClick,
                onInviteClick = onInviteClick,
                onInvitedUsersClick = onInvitedUsersClick
            )

            Spacer(modifier = Modifier.height(20.dp))



            Spacer(modifier = Modifier.height(20.dp))

            // 功能菜单列表
            MenuListCard(
                userRole = viewModel.userRole,  // 传递用户角色
                onCustomerServiceClick = { showCustomerServiceDialog = true },
                onAboutClick = onAboutClick,
                onLogout = onLogout,
                onUploadProductClick = onUploadProductClick,  // 传递上传商品回调
                onInviteClick = onInviteClick  // 传递邀请回调
            )

            Spacer(modifier = Modifier.height(20.dp))

            // 退出登录按钮
            LogoutButton(onLogout = onLogout)

            // 底部安全区域适配
            Spacer(modifier = Modifier
                .fillMaxWidth()
                .windowInsetsBottomHeight(WindowInsets.navigationBars)
            )

            Spacer(modifier = Modifier.height(16.dp))
        }
    }

    // 客服联系对话框
    if (showCustomerServiceDialog) {
        CustomerServiceDialog(
            onDismiss = { showCustomerServiceDialog = false }
        )
    }

    // 升级支付弹框
    if (showUpgradeDialog) {
        UpgradePaymentDialog(
            currentBalance = viewModel.balance ?: 0.0,
            upgradePrice = 999.0,
            onDismiss = { showUpgradeDialog = false },
            onBalancePayment = {
                println("ProfileScreen - 选择余额支付升级")
                viewModel.upgradeToAffiliate()
                showUpgradeDialog = false
            }
        )
    }

    // 支付宝二维码弹框
    if (showAlipayDialog && alipayQrcodeUrl != null) {
        UpgradeAlipayQrcodeDialog(
            qrcodeUrl = alipayQrcodeUrl!!,
            orderNo = alipayOrderNo ?: "",
            viewModel = viewModel,
            onDismiss = {
                showAlipayDialog = false
                alipayQrcodeUrl = null
                alipayOrderNo = null
            },
            onPaymentSuccess = {
                showAlipayDialog = false
                alipayQrcodeUrl = null
                alipayOrderNo = null
                // 重新加载数据
                viewModel.loadBalance()
                viewModel.loadUserRole()
            }
        )
    }
}

/**
 * 用户信息卡片 - 按照设计图实现
 */
@Composable
fun UserInfoCard(
    username: String?,
    userRole: String?
) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(
            containerColor = Color.White
        ),
        elevation = CardDefaults.cardElevation(2.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 32.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // 头像
            Box(
                modifier = Modifier
                    .size(80.dp)
                    .background(Color(0xFFF0F0F0), CircleShape),
                contentAlignment = Alignment.Center
            ) {
                Image(
                    painter = painterResource(Res.drawable.compose_multiplatform) ,
                    contentDescription = "头像",
                    modifier = Modifier.size(50.dp)
                )
            }

            Spacer(modifier = Modifier.height(16.dp))

            // 用户名
            Text(
                text = username ?: "未知用户",
                fontSize = 18.sp,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF333333),
                fontFamily = CaiFont
            )

            Spacer(modifier = Modifier.height(8.dp))

            // 邀请码
            SelectionContainer {
                Text(
                    text = "邀请码: ${TokenManager.getReferralCode() ?: "未获取"}",
                    fontSize = 14.sp,
                    color = Color(0xFF999999),
                    fontFamily = CaiFont
                )
            }

            Spacer(modifier = Modifier.height(8.dp))


        }
    }
}

/**
 * 角色徽章
 */
@Composable
fun RoleBadge(role: String) {
    val (text, backgroundColor, textColor) = when (role) {
        "admin" -> Triple("管理员", Color(0xFFFF5252), Color.White)
        "affiliate" -> Triple("加盟商", Color(0xFFFFB300), Color.White)
        "user" -> Triple("普通用户", Color(0xFF64B5F6), Color.White)
        else -> Triple(role, Color.Gray, Color.White)
    }

    Surface(
        shape = RoundedCornerShape(4.dp),
        color = backgroundColor,
        modifier = Modifier
    ) {
        Text(
            text = text,
            fontSize = 11.sp,
            color = textColor,
            fontFamily = CaiFont,
            modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp)
        )
    }
}

/**
 * 余额卡片和升级按钮
 */
@Composable
fun BalanceCard(
    balance: Double?,
    isLoading: Boolean,
    userRole: String?,
    onUpgradeClick: () -> Unit,
    onWithdrawClick: () -> Unit = {},  // 提现回调
    onRechargeClick: () -> Unit = {}   // 充值回调
) {
    println("BalanceCard - 用户角色: $userRole") // 日志输出
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(2.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(20.dp)
        ) {
            // 余额显示
            Column {
                Text(
                    text = "账户余额",
                    fontSize = 14.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont
                )
                Spacer(modifier = Modifier.height(8.dp))
                if (isLoading) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(24.dp),
                        strokeWidth = 2.dp
                    )
                } else {
                    Text(
                        text = "￥${balance ?: 0.0}",
                        fontSize = 28.sp,
                        fontWeight = FontWeight.Bold,
                        color = Color(0xFFFF6F00),
                        fontFamily = CaiFont
                    )
                }

            }

            Spacer(modifier = Modifier.height(16.dp))

            // 操作按钮行
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                // 提现按钮
                OutlinedButton(
                    onClick = {
                        println("EarningsSection - 点击提现按钮") // 日志输出
                        onWithdrawClick()
                    },
                    colors = ButtonDefaults.outlinedButtonColors(
                        contentColor = Color(0xFFFF6F00)
                    ),
                    shape = RoundedCornerShape(20.dp),
                    modifier = Modifier.weight(1f).height(40.dp)
                ) {
                    Icon(
                        imageVector = Icons.Default.AccountBalanceWallet,
                        contentDescription = "提现",
                        modifier = Modifier.size(18.dp)
                    )
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(
                        text = "提现",
                        fontFamily = CaiFont,
                        fontSize = 14.sp
                    )
                }

//                // 充值按钮
//                OutlinedButton(
//                    onClick = {
//                        println("BalanceCard - 点击充值按钮") // 日志输出
//                        onRechargeClick()
//                    },
//                    colors = ButtonDefaults.outlinedButtonColors(
//                        contentColor = Color(0xFF4CAF50)
//                    ),
//                    shape = RoundedCornerShape(20.dp),
//                    modifier = Modifier.weight(1f).height(40.dp)
//                ) {
//                    Icon(
//                        imageVector = Icons.Default.Add,
//                        contentDescription = "充值",
//                        modifier = Modifier.size(18.dp)
//                    )
//                    Spacer(modifier = Modifier.width(4.dp))
//                    Text(
//                        text = "充值",
//                        fontFamily = CaiFont,
//                        fontSize = 14.sp
//                    )
//                }
            }
        }
    }
}

/**
 * 订单状态项
 */
@Composable
fun OrderStatusItem(icon: ImageVector, label: String) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Icon(
            imageVector = icon,
            contentDescription = label,
            tint = Color(0xFF1E88E5),
            modifier = Modifier.size(32.dp)
        )
        Spacer(modifier = Modifier.height(8.dp))
        Text(
            text = label,
            fontSize = 12.sp,
            fontFamily = CaiFont
        )
    }
}

/**
 * 收益区域组件
 */
@Composable
fun EarningsSection(
    earnings: Double?,
    isLoading: Boolean,
    onRecordClick: () -> Unit,
    onWithdrawClick: () -> Unit  // 新增提现回调
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(16.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column {
            Text(
                text = "总收益",
                fontSize = 14.sp,
                color = Color.Gray,
                fontFamily = CaiFont
            )
            Spacer(modifier = Modifier.height(8.dp))
            if (isLoading) {
                CircularProgressIndicator(
                    modifier = Modifier.size(24.dp),
                    strokeWidth = 2.dp
                )
            } else {
                Text(
                    text = "￥${earnings ?: 0.0}",
                    fontSize = 24.sp,
                    fontWeight = FontWeight.Bold,
                    color = Color(0xFF34BA7C),
                    fontFamily = CaiFont
                )
            }
        }


        // 收益记录按钮
        OutlinedButton(
            onClick = {
                println("EarningsSection - 点击收益记录按钮") // 日志输出
                onRecordClick()
            },
            colors = ButtonDefaults.outlinedButtonColors(
                contentColor = Color(0xFF1E88E5)
            ),
            shape = RoundedCornerShape(20.dp),
            modifier = Modifier.height(40.dp),
            contentPadding = PaddingValues(horizontal = 16.dp, vertical = 0.dp)
        ) {
            Icon(
                imageVector = Icons.Default.Receipt,
                contentDescription = "收益记录",
                modifier = Modifier.size(18.dp)
            )
            Spacer(modifier = Modifier.width(4.dp))
            Text(
                text = "收益记录",
                fontFamily = CaiFont,
                fontSize = 14.sp
            )
        }

    }
}

/**
 * 区块卡片
 */
@Composable
fun SectionCard(title: String, content: @Composable () -> Unit) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(2.dp)
    ) {
        Column {
            Text(
                text = title,
                fontSize = 16.sp,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(16.dp),
                fontFamily = CaiFont
            )
            content()
        }
    }
}

/**
 * 菜单项
 */
@Composable
fun MenuItem(
    icon: ImageVector,
    label: String,
    onClick: (() -> Unit)? = null
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .let { modifier ->
                if (onClick != null) {
                    modifier.clickable {
                        println("MenuItem - 点击菜单项: $label") // 日志输出
                        onClick()
                    }
                } else {
                    modifier
                }
            }
            .padding(horizontal = 16.dp, vertical = 16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            imageVector = icon,
            contentDescription = label,
            tint = Color(0xFF1E88E5),
            modifier = Modifier.size(24.dp)
        )
        Spacer(modifier = Modifier.width(16.dp))
        Text(
            text = label,
            fontSize = 15.sp,
            modifier = Modifier.weight(1f),
            fontFamily = CaiFont
        )
        Icon(
            imageVector = Icons.AutoMirrored.Filled.ArrowForward,
            contentDescription = "进入",
            tint = Color.Gray,
            modifier = Modifier.size(20.dp)
        )
    }
}

/**
 * 客服联系对话框
 */
@Composable
fun CustomerServiceDialog(
    onDismiss: () -> Unit
) {
    Dialog(onDismissRequest = onDismiss) {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            shape = RoundedCornerShape(16.dp),
            colors = CardDefaults.cardColors(containerColor = Color.White)
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(24.dp)
            ) {
                // 标题
                Text(
                    text = "客服联系方式",
                    fontSize = 20.sp,
                    fontWeight = FontWeight.Bold,
                    fontFamily = CaiFont,
                    modifier = Modifier.padding(bottom = 16.dp)
                )

                // 客服邮箱 1
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 8.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        imageVector = Icons.Default.Email,
                        contentDescription = "邮箱",
                        tint = Color(0xFF1E88E5),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(modifier = Modifier.width(12.dp))
                    Column {
                        Text(
                            text = "客服邮箱 1",
                            fontSize = 12.sp,
                            color = Color.Gray,
                            fontFamily = CaiFont
                        )
                        SelectionContainer {
                            Text(
                                text = "565150953@qq.com",
                                fontSize = 16.sp,
                                fontWeight = FontWeight.Medium,
                                fontFamily = CaiFont,
                                color = Color(0xFF1E88E5)
                            )
                        }
                    }
                }

                Divider(
                    modifier = Modifier.padding(vertical = 12.dp),
                    color = Color(0xFFEEEEEE)
                )

                // 客服邮箱 2
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 8.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        imageVector = Icons.Default.Email,
                        contentDescription = "邮箱",
                        tint = Color(0xFF1E88E5),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(modifier = Modifier.width(12.dp))
                    Column {
                        Text(
                            text = "客服邮箱 2",
                            fontSize = 12.sp,
                            color = Color.Gray,
                            fontFamily = CaiFont
                        )
                        SelectionContainer {
                            Text(
                                text = "1161876426@qq.com",
                                fontSize = 16.sp,
                                fontWeight = FontWeight.Medium,
                                fontFamily = CaiFont,
                                color = Color(0xFF1E88E5)
                            )
                        }
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 提示信息
                SelectionContainer {
                    Text(
                        text = "请通过以上邮箱联系我们，我们会尽快回复您。长按邮箱可复制。",
                        fontSize = 14.sp,
                        color = Color.Gray,
                        fontFamily = CaiFont,
                        modifier = Modifier.padding(bottom = 16.dp)
                    )
                }

                // 关闭按钮
                Button(
                    onClick = onDismiss,
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(48.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = Color(0xFF1E88E5)
                    ),
                    shape = RoundedCornerShape(12.dp)
                ) {
                    Text(
                        text = "关闭",
                        fontSize = 16.sp,
                        fontWeight = FontWeight.Bold,
                        fontFamily = CaiFont
                    )
                }
            }
        }
    }
}

/**
 * 升级支付弹框（仅支持余额支付）
 */
@Composable
fun UpgradePaymentDialog(
    currentBalance: Double,
    upgradePrice: Double,
    onDismiss: () -> Unit,
    onBalancePayment: () -> Unit
) {
    Dialog(onDismissRequest = onDismiss) {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            shape = RoundedCornerShape(16.dp),
            colors = CardDefaults.cardColors(containerColor = Color.White)
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(24.dp)
            ) {
                // 标题
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = "升级为加盟商",
                        fontSize = 20.sp,
                        fontWeight = FontWeight.Bold,
                        fontFamily = CaiFont
                    )
                    IconButton(
                        onClick = onDismiss,
                        modifier = Modifier.size(24.dp)
                    ) {
                        Icon(
                            imageVector = Icons.Default.Close,
                            contentDescription = "关闭",
                            tint = Color.Gray
                        )
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 价格信息
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = Color(0xFFFFF3E0)
                    )
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            Text(
                                text = "升级费用",
                                fontSize = 14.sp,
                                color = Color.Gray,
                                fontFamily = CaiFont
                            )
                            Text(
                                text = "￥$upgradePrice",
                                fontSize = 24.sp,
                                fontWeight = FontWeight.Bold,
                                color = Color(0xFFFF6F00),
                                fontFamily = CaiFont
                            )
                        }
                        Spacer(modifier = Modifier.height(8.dp))
                        Text(
                            text = "当前余额: ￥$currentBalance",
                            fontSize = 12.sp,
                            color = Color.Gray,
                            fontFamily = CaiFont
                        )
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 权益说明
                Text(
                    text = "升级后将享受以下权益：",
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Medium,
                    fontFamily = CaiFont,
                    modifier = Modifier.padding(bottom = 8.dp)
                )

                BenefitItem("获得下级用户购买商品的提成")
                BenefitItem("可以邀请更多用户加入")
                BenefitItem("享受更高的收益比例")

                Spacer(modifier = Modifier.height(20.dp))

                // 支付方式标题
                Text(
                    text = "请选择支付方式",
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Medium,
                    fontFamily = CaiFont,
                    modifier = Modifier.padding(bottom = 12.dp)
                )

                // 余额支付按钮
                Button(
                    onClick = onBalancePayment,
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(50.dp),
                    enabled = currentBalance >= upgradePrice,
                    colors = ButtonDefaults.buttonColors(
                        containerColor = Color(0xFF4CAF50),
                        disabledContainerColor = Color(0xFFBDBDBD)
                    ),
                    shape = RoundedCornerShape(12.dp)
                ) {
                    Icon(
                        imageVector = Icons.Default.AccountBalanceWallet,
                        contentDescription = null,
                        modifier = Modifier.size(20.dp)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        text = if (currentBalance >= upgradePrice) "余额支付" else "余额不足",
                        fontSize = 16.sp,
                        fontWeight = FontWeight.Bold,
                        fontFamily = CaiFont
                    )
                }

//                Spacer(modifier = Modifier.height(12.dp))
//
//                // 支付宝支付按钮
//                Button(
//                    onClick = onAlipayPayment,
//                    modifier = Modifier
//                        .fillMaxWidth()
//                        .height(50.dp),
//                    colors = ButtonDefaults.buttonColors(
//                        containerColor = Color(0xFF1E88E5)
//                    ),
//                    shape = RoundedCornerShape(12.dp)
//                ) {
//                    Icon(
//                        imageVector = Icons.Default.Payment,
//                        contentDescription = null,
//                        modifier = Modifier.size(20.dp)
//                    )
//                    Spacer(modifier = Modifier.width(8.dp))
//                    Text(
//                        text = "支付宝支付",
//                        fontSize = 16.sp,
//                        fontWeight = FontWeight.Bold,
//                        fontFamily = CaiFont
//                    )
//                }
            }
        }
    }
}

/**
 * 权益项
 */
@Composable
fun BenefitItem(text: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            imageVector = Icons.Default.CheckCircle,
            contentDescription = null,
            tint = Color(0xFF4CAF50),
            modifier = Modifier.size(16.dp)
        )
        Spacer(modifier = Modifier.width(8.dp))
        Text(
            text = text,
            fontSize = 13.sp,
            color = Color(0xFF666666),
            fontFamily = CaiFont
        )
    }
}

/**
 * 升级支付宝二维码弹框
 */
@Composable
fun UpgradeAlipayQrcodeDialog(
    qrcodeUrl: String,
    orderNo: String,
    viewModel: ProfileViewModel,
    onDismiss: () -> Unit,
    onPaymentSuccess: () -> Unit
) {
    println("UpgradeAlipayQrcodeDialog - 显示支付宝二维码弹框: $qrcodeUrl")

    var isChecking by remember { mutableStateOf(false) }
    var checkErrorMessage by remember { mutableStateOf<String?>(null) }
    val coroutineScope = rememberCoroutineScope()
    val token = TokenManager.getToken()

    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = "支付宝扫码支付",
                    fontSize = 20.sp,
                    fontWeight = FontWeight.Bold,
                    fontFamily = CaiFont
                )
                IconButton(
                    onClick = onDismiss,
                    modifier = Modifier.size(24.dp)
                ) {
                    Icon(
                        imageVector = Icons.Default.Close,
                        contentDescription = "关闭",
                        tint = Color.Gray
                    )
                }
            }
        },
        text = {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    text = "请使用支付宝扫描下方二维码完成支付",
                    fontSize = 14.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont,
                    modifier = Modifier.padding(bottom = 16.dp)
                )

                // 二维码图片
                Box(
                    modifier = Modifier
                        .size(250.dp)
                        .background(Color.White, RoundedCornerShape(12.dp))
                        .padding(16.dp),
                    contentAlignment = Alignment.Center
                ) {
                    coil3.compose.AsyncImage(
                        model = qrcodeUrl,
                        contentDescription = "支付宝二维码",
                        modifier = Modifier.fillMaxSize()
                    )
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 错误信息
                if (checkErrorMessage != null) {
                    Text(
                        text = checkErrorMessage!!,
                        fontSize = 12.sp,
                        color = Color.Red,
                        fontFamily = CaiFont,
                        modifier = Modifier.padding(vertical = 8.dp)
                    )
                }

                // 提示信息
                Text(
                    text = "支付完成后请点击下方按钮检查支付状态",
                    fontSize = 12.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont,
                    modifier = Modifier.padding(top = 8.dp)
                )
            }
        },
        confirmButton = {
            Button(
                onClick = {
                    if (token.isNullOrEmpty()) {
                        checkErrorMessage = "未登录，无法检查支付状态"
                        return@Button
                    }

                    isChecking = true
                    checkErrorMessage = null

                    coroutineScope.launch {
                        try {
                            println("UpgradeAlipayQrcodeDialog - 检查支付状态，订单号: $orderNo")
                            val checkResponse = viewModel.repository.getOrderDetail(orderNo, token)

                            if (checkResponse.isSuccess) {
                                val checkOrderDetail = checkResponse.getOrNull()
                                if (checkOrderDetail?.code == 200 && checkOrderDetail.data != null) {
                                    val payStatus = checkOrderDetail.data.payStatus
                                    println("UpgradeAlipayQrcodeDialog - 当前支付状态: $payStatus")

                                    if (payStatus == 1) {
                                        println("UpgradeAlipayQrcodeDialog - 支付成功！")
                                        onPaymentSuccess()
                                    } else {
                                        checkErrorMessage = "请先完成支付，然后再检查状态"
                                    }
                                } else {
                                    checkErrorMessage = "检查失败: ${checkOrderDetail?.message}"
                                }
                            } else {
                                checkErrorMessage = "网络请求失败，请稍后重试"
                            }
                        } catch (e: Exception) {
                            println("UpgradeAlipayQrcodeDialog - 检查异常: ${e.message}")
                            checkErrorMessage = "检查异常: ${e.message}"
                        } finally {
                            isChecking = false
                        }
                    }
                },
                enabled = !isChecking,
                colors = ButtonDefaults.buttonColors(
                    containerColor = Color(0xFF1E88E5)
                )
            ) {
                if (isChecking) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(20.dp),
                        color = Color.White,
                        strokeWidth = 2.dp
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        text = "检查中...",
                        fontFamily = CaiFont
                    )
                } else {
                    Text(
                        text = "我已支付，检查状态",
                        fontFamily = CaiFont
                    )
                }
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(
                    text = "取消",
                    fontFamily = CaiFont
                )
            }
        }
    )
}

/**
 * 功能菜单列表卡片
 */
@Composable
fun MenuListCard(
    userRole: String?,  // 用户角色
    onCustomerServiceClick: () -> Unit,
    onAboutClick: () -> Unit,
    onLogout: () -> Unit,
    onUploadProductClick: () -> Unit,  // 上传商品回调
    onInviteClick: () -> Unit = {}  // 邀请回调
) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(
            containerColor = Color.White
        ),
        elevation = CardDefaults.cardElevation(2.dp)
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {

            // 如果用户已升级为admin，显示上传商品菜单
            if (userRole == "admin") {
                MenuItemRow(
                    icon = Icons.Default.Add,
                    iconColor = Color(0xFFFF6F00),
                    iconBackgroundColor = Color(0xFFFFE0B2),
                    title = "上传商品",
                    subtitle = "管理员专属功能",
                    onClick = onUploadProductClick
                )
                Divider(color = Color(0xFFEEEEEE), thickness = 0.5.dp)
            }

            // 邀请好友菜单
            MenuItemRow(
                icon = Icons.Default.PersonAdd,
                iconColor = Color(0xFFFF6F00),
                iconBackgroundColor = Color(0xFFFFE0B2),
                title = "邀请好友",
                subtitle = "邀请好友获取收益",
                onClick = onInviteClick
            )
            Divider(color = Color(0xFFEEEEEE), thickness = 0.5.dp)

            // Android 应用下载
            MenuItemRow(
                icon = Icons.Default.AccountTree,
                iconColor = Color(0xFF4A90E2),
                iconBackgroundColor = Color(0xFFE3F2FD),
                title = "Android 应用下载",
                subtitle = "",
                onClick = {
                    println("ProfileScreen - 点击Android应用下载")
                    UrlLauncher.openUrl("https://updata.aiotzq.com/学库.apk")
                }
            )
            Divider(color = Color(0xFFEEEEEE), thickness = 0.5.dp)
            // 联系客服
            MenuItemRow(
                icon = Icons.Default.Phone,
                iconColor = Color(0xFF4A90E2),
                iconBackgroundColor = Color(0xFFE3F2FD),
                title = "联系客服",
                subtitle = "7×24小时在线服务",
                onClick = onCustomerServiceClick
            )

            Divider(color = Color(0xFFEEEEEE), thickness = 0.5.dp)

            // 关于我们
            MenuItemRow(
                icon = Icons.Default.Info,
                iconColor = Color(0xFF66BB6A),
                iconBackgroundColor = Color(0xFFE8F5E9),
                title = "关于我们",
                subtitle = "版本号 v3.2.1",
                onClick = onAboutClick
            )


        }
    }
}

/**
 * 菜单项
 */
@Composable
fun MenuItemRow(
    icon: ImageVector,
    iconColor: Color,
    iconBackgroundColor: Color,
    title: String,
    subtitle: String,
    onClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        // 图标
        Box(
            modifier = Modifier
                .size(40.dp)
                .background(iconBackgroundColor, RoundedCornerShape(8.dp)),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                imageVector = icon,
                contentDescription = title,
                tint = iconColor,
                modifier = Modifier.size(24.dp)
            )
        }

        Spacer(modifier = Modifier.width(12.dp))

        // 文字信息
        Column(
            modifier = Modifier.weight(1f)
        ) {
            Text(
                text = title,
                fontSize = 16.sp,
                fontWeight = FontWeight.Medium,
                color = Color(0xFF333333),
                fontFamily = CaiFont
            )
            if (subtitle.isNotEmpty()) {
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    text = subtitle,
                    fontSize = 12.sp,
                    color = Color(0xFF999999),
                    fontFamily = CaiFont
                )
            }
        }

        // 箭头
        Icon(
            imageVector = Icons.AutoMirrored.Filled.ArrowForward,
            contentDescription = "进入",
            tint = Color(0xFFCCCCCC),
            modifier = Modifier.size(20.dp)
        )
    }
}

/**
 * 退出登录按钮
 */
@Composable
fun LogoutButton(onLogout: () -> Unit) {
    Button(
        onClick = onLogout,
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .height(50.dp),
        shape = RoundedCornerShape(25.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = Color(0xFFE53935)
        )
    ) {
        Icon(
            imageVector = Icons.Default.ExitToApp,
            contentDescription = "退出登录",
            tint = Color.White,
            modifier = Modifier.size(20.dp)
        )
        Spacer(modifier = Modifier.width(8.dp))
        Text(
            text = "退出登录",
            fontSize = 16.sp,
            fontWeight = FontWeight.Medium,
            color = Color.White,
            fontFamily = CaiFont
        )
    }
}

/**
 * 收藏和喜欢按钮组
 */
@Composable
fun FavoriteAndLikeButtons(
    onFavoriteClick: () -> Unit,
    onLikeClick: () -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        // 收藏按钮
        Button(
            onClick = onFavoriteClick,
            modifier = Modifier
                .weight(1f)
                .height(70.dp),
            shape = RoundedCornerShape(12.dp),
            colors = ButtonDefaults.buttonColors(
                containerColor = Color(0xFFFF6F00)
            )
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                Icon(
                    imageVector = Icons.Default.Star,
                    contentDescription = "收藏",
                    tint = Color.White,
                    modifier = Modifier.size(24.dp)
                )
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    text = "收藏",
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Medium,
                    color = Color.White,
                    fontFamily = CaiFont
                )
            }
        }

        // 喜欢按钮
        Button(
            onClick = onLikeClick,
            modifier = Modifier
                .weight(1f)
                .height(70.dp),
            shape = RoundedCornerShape(12.dp),
            colors = ButtonDefaults.buttonColors(
                containerColor = Color(0xFFE91E63)
            )
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                Icon(
                    imageVector = Icons.Default.Favorite,
                    contentDescription = "喜欢",
                    tint = Color.White,
                    modifier = Modifier.size(24.dp)
                )
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    text = "喜欢",
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Medium,
                    color = Color.White,
                    fontFamily = CaiFont
                )
            }
        }
    }
}

/**
 * 我的收益卡片
 * 包含总收益显示、收益记录、我的邀请等功能入口
 */
@Composable
fun MyEarningsCard(
    earnings: Double?,
    isLoading: Boolean,
    onEarningsRecordClick: () -> Unit,
    onInviteClick: () -> Unit,
    onInvitedUsersClick: () -> Unit
) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(2.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(20.dp)
        ) {
            // 标题
            Text(
                text = "我的收益",
                fontSize = 16.sp,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF333333),
                fontFamily = CaiFont
            )

            Spacer(modifier = Modifier.height(16.dp))

            // 总收益显示
            Column {
                Text(
                    text = "总收益",
                    fontSize = 14.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont
                )
                Spacer(modifier = Modifier.height(8.dp))
                if (isLoading) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(24.dp),
                        strokeWidth = 2.dp
                    )
                } else {
                    Text(
                        text = "￥${earnings ?: 0.0}",
                        fontSize = 32.sp,
                        fontWeight = FontWeight.Bold,
                        color = Color(0xFF34BA7C),
                        fontFamily = CaiFont
                    )
                }
            }

            Spacer(modifier = Modifier.height(20.dp))

            // 功能按钮行
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                // 收益记录按钮
                EarningsActionButton(
                    icon = Icons.Default.Receipt,
                    label = "收益记录",
                    onClick = {
                        println("MyEarningsCard - 点击收益记录") // 日志输出
                        onEarningsRecordClick()
                    },
                    modifier = Modifier.weight(1f)
                )

                // 我的邀请按钮
                EarningsActionButton(
                    icon = Icons.Default.People,
                    label = "我的邀请",
                    onClick = {
                        println("MyEarningsCard - 点击我的邀请") // 日志输出
                        onInvitedUsersClick()
                    },
                    modifier = Modifier.weight(1f)
                )

                // 邀请好友按钮
                EarningsActionButton(
                    icon = Icons.Default.PersonAdd,
                    label = "邀请好友",
                    onClick = {
                        println("MyEarningsCard - 点击邀请好友") // 日志输出
                        onInviteClick()
                    },
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}

/**
 * 收益功能按钮
 */
@Composable
fun EarningsActionButton(
    icon: ImageVector,
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    OutlinedButton(
        onClick = onClick,
        modifier = modifier.height(80.dp),
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.outlinedButtonColors(
            contentColor = Color(0xFF34BA7C)
        ),
        border = BorderStroke(1.dp, Color(0xFF34BA7C))
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Icon(
                imageVector = icon,
                contentDescription = label,
                modifier = Modifier.size(24.dp),
                tint = Color(0xFF34BA7C)
            )
            Spacer(modifier = Modifier.height(8.dp))
            Text(
                text = label,
                fontSize = 12.sp,
                fontFamily = CaiFont,
                color = Color(0xFF34BA7C)
            )
        }
    }
}